// test2397
(2397 && 0);
